export const getFilterButtonId = (name: string): string => {
    switch (name) {
        case 'energies.Diesel':
        case 'fuel.Diesel':
            return 'TESTING_DIESEL';
        case 'energies.Essence':
        case 'fuel.Essence':
            return 'TESTING_ESSENCE';
        case 'energies.Hybride-Essence':
        case 'fuel.Hybride-Essence':
            return 'TESTING_HYBRID';
        case 'gearboxTypes.Manuelle':
        case 'gearbox.Manuelle':
            return 'TESTING_MAN';
        case 'gearboxTypes.Automatique':
        case 'gearbox.Automatique':
            return 'TESTING_AUTOMATIC';
        default:
            return '';
    }
};
